export default __webpack_public_path__ + "images/9e41f4ebc70f7edfb52d8130aef011ac.png";